import { render, staticRenderFns } from "./ListApartments.vue?vue&type=template&id=9876cda4&scoped=true"
import script from "./ListApartments.vue?vue&type=script&lang=ts"
export * from "./ListApartments.vue?vue&type=script&lang=ts"
import style0 from "./ListApartments.vue?vue&type=style&index=0&id=9876cda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9876cda4",
  null
  
)

export default component.exports